module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.player.name),
      expression: "player.name"
    }],
    domProps: {
      "value": _vm._s(_vm.player.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.player.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.$emit('removePlayer')
      }
    }
  }, [_vm._v("Remove")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53eb4c08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SetupPlayer.vue
// module id = 92
// module chunks = 2